import { message } from 'antd'

const AntMessageStyled = message
export default AntMessageStyled
